import { getManagementData, setManagementData } from './localStorageManager.js';
import loginApi from '../api/login.js';

/**
 * 更新並儲存管理員可管理的城市資料
 * @returns {Promise<boolean>} - 回傳 Promise，成功時 resolve true，失敗時 reject false
 */
export const updateManageableCities = async () => {
    try {
        const cities = await loginApi.manageableCities();
        setManagementData(cities);
        return true;
    } catch (error) {
        console.error('Failed to update manageable cities list:', error);
        // 這裡可以選擇性地顯示錯誤訊息給使用者
        return false;
    }
};

/**
 * 取得特定國家的所有城市資料
 * @param {string} countryID - 國家 ID
 * @returns {Array} 指定國家的城市物件陣列，包含 cityID、name、districts、language，若找不到則回傳空陣列
 */
export const getCities = (countryID) => {
    if (!countryID) return [];

    const managementData = getManagementData();
    if (!managementData) return [];

    const country = managementData.find(c => c.countryID === countryID);
    return country && country.cities ? country.cities : [];
};

/**
 * 取得目前管理員可管理的國家清單
 * 如果 managementCities 中有 cityID '0'，則回傳所有國家
 * 否則從可管理城市清單中推斷國家
 * @returns {Array<{countryID: string, name: string}>} 國家物件陣列
 */
export const getManageCountry = () => {
    const managementData = getManagementData();

    if (!managementData || managementData.length === 0) {
        return [];
    }

    return managementData.map(country => ({
        countryID: country.countryID,
        name: country.name
    }));
};

/**
 * 取得目前管理員可管理的城市清單
 * 如果 managementCities 中有 cityID '0'，則回傳所有城市
 * 否則回傳 managementCities 中指定的城市及其名稱、區域、語言資訊
 * @returns {Array<{cityID: string, name: string, districts: string, language: string}>} 城市物件陣列
 */
export const getManageCity = () => {
    const managementData = getManagementData();

    if (!managementData || managementData.length === 0) {
        return [];
    }

    const manageableCities = [];
    managementData.forEach(country => {
        if (country.cities && Array.isArray(country.cities)) {
            country.cities.forEach(city => {
                manageableCities.push({
                    cityID: city.cityID,
                    name: city.name,
                    districts: city.districts || '', // 確保 districts 欄位存在，預設為空字串
                    language: city.language || ''    // 確保 language 欄位存在，預設為空字串
                });
            });
        }
    });
    return manageableCities;
}; 